export default __webpack_public_path__ + "static/media/BarGraph.79fe667e.mp4";